// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"501":"7faf3324","518":"de05200e","667":"2536c546"}[chunkId] + ".chunk.js";
};